import { Breadcrumbs, Anchor, createStyles, ScrollArea } from '@mantine/core';
import withRouter from '../../utility/react-router-dom/witrouter-compo';
import style from './breadcrumbCompoStyle.module.css';
const useStyles = createStyles((theme) => ({
  scrollarea: {
    marginTop: 130,
    marginBottom: 25,
    '@media (max-width: 600px)': {
      marginTop: 0,
    },
  },
  breadcrumbs: {
    backgroundColor: '#F2CD00',
    height: 70,
  },
  textAnchor: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 400,
    fontSize: 16,
    color: '#000000',
  },
  pembungkusAnchor: {
    background: '#F2CD00',
    paddingLeft: 20,
    transition: '0.5s',
    '@media (min-width: 600px)': {
      paddingLeft: 100,
      transition: '0.5s',
    },
    '@media (min-width: 1200px)': {
      paddingLeft: 250,
      transition: '0.5s',
    },
    '@media (min-width: 1600px)': {
      paddingLeft: 400,
      transition: '0.5s',
    },
  },
}));

const BreadCrumbCompo = (props) => {
  const { classes } = useStyles();
  console.log(props);
  const items = [
    { title: 'Beranda', href: '#' },
    { title: 'Bondowoso', href: '#' },
    { title: 'Dijual', href: '#' },
    { title: 'Wijaya Kusuma', href: '#' },
  ].map((item, index) => (
    <Anchor className={classes.textAnchor} href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));
  return (
    <>
      <ScrollArea className={classes.scrollarea}>
        <div className={classes.linkBreadcrumbs}>
          <div className={classes.pembungkusAnchor}>
            <Breadcrumbs separator=">" className={classes.breadcrumbs}>
              {items}
            </Breadcrumbs>

            {/* <Breadcrumbs separator=">">{props.items}</Breadcrumbs> */}
            {/* <Breadcrumbs
            separator=">"
            className={`${classes.breadcrumbs} ${style.breadcrumbContainer}`}
            py={20}
          >
            <Anchor
              href="/#"
              target="_blank"
              color="dark.9"
              className={`${style.anchor} ${style['mantine-eg3tel']} ${classes.textAnchor} ps-5`}
            >
              {props.items}
            </Anchor>
            <Anchor
              href="/#"
              target="_blank"
              color="dark.9"
              className={`${style['mantine-eg3tel']} ${classes.textAnchor}`}
            >
              Bondowoso
            </Anchor>
            <Anchor
              href="/#"
              target="_blank"
              color="dark.9"
              className={`${style['mantine-eg3tel']} ${classes.textAnchor}`}
            >
              Dijual
            </Anchor>
            <Anchor
              href="/#"
              target="_blank"
              color="dark.9"
              className={`${style['mantine-eg3tel']} ${classes.textAnchor}`}
            >
              Wijaya Kusuma
            </Anchor>
          </Breadcrumbs> */}
            {/* <Breadcrumbs>{items}</Breadcrumbs>
          <Breadcrumbs separator=">">{items}</Breadcrumbs> */}
            {/* {props.crumbs.map((crumb, ci) => {
            const disabled = isLast(ci) ? 'disabled' : '';
            return (
              <>
                <Breadcrumbs
                  separator=">"
                  className={`${classes.breadcrumbs} ${style.breadcrumbContainer}`}
                  py={20}
                >
                  <Anchor
                    href="/#"
                    target="_blank"
                    color="dark.9"
                    className={`${style.anchor} ${style['mantine-eg3tel']} ${classes.textAnchor} ps-5`}
                  >
                    {props.crumbs}
                  </Anchor>
                  <Anchor
                    href="/#"
                    target="_blank"
                    color="dark.9"
                    className={`${style['mantine-eg3tel']} ${classes.textAnchor}`}
                  >
                    {props.crumbs}
                  </Anchor>
                  <Anchor
                    href="/#"
                    target="_blank"
                    color="dark.9"
                    className={`${style['mantine-eg3tel']} ${classes.textAnchor}`}
                  >
                    {props.crumbs}
                  </Anchor>
                  <Anchor
                    href="/#"
                    target="_blank"
                    color="dark.9"
                    className={`${style['mantine-eg3tel']} ${classes.textAnchor}`}
                  >
                    {props.crumbs}
                  </Anchor>
                </Breadcrumbs>
              </>
            );
          })} */}
          </div>
        </div>
      </ScrollArea>
    </>
  );
};

export default withRouter(BreadCrumbCompo);
